import { Breadcrumbs } from '@app/components/breadcrumbs';
import { LanguageSwitcher } from '@app/components/language-switcher';
import { SidebarTrigger } from '@app/components/ui/sidebar';
import {useBreadcrumbsList} from '@app/hooks/context/BreadcrumbsContext';

export function AppSidebarHeader() {

    const breadcrumbs = useBreadcrumbsList();

    return (
        <header className="border-sidebar-border/50 flex h-16 shrink-0 items-center gap-2 border-b px-6 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12 md:px-4">
            <div className="flex w-full items-center justify-between">
                <div className="flex items-center gap-2">
                    <SidebarTrigger className="-ml-1" />
                    <Breadcrumbs breadcrumbs={breadcrumbs} />
                </div>
                <div className="flex items-center gap-2">
                    <LanguageSwitcher />
                </div>
            </div>
        </header>
    );
}
